export const RoutesNames = {
   home: '/',
   login: '/login',
   leaderboard: '/leaderboard'
};
